(ns practitest.frontend.components.account-layout.account-items
  (:require
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]))

(defn- base-items [new-users-view?]
  [{:text-key "navigation.account-settings-panel.general"
    :default-text "General"
    :id "account-settings-panel-general"
    :icon icons/mux-smile-square-icon
    :route "account/accounts#settings"}
   {:text-key "navigation.account-settings-panel.subscriptions"
    :default-text "Subscriptions"
    :id "account-settings-panel-subscriptions"
    :icon icons/mux-cash-payment-icon
    :route "account/accounts#subscriptions"}
   {:text-key "navigation.account-settings-panel.projects"
    :default-text "Projects Management"
    :id "account-settings-panel-projects"
    :icon icons/mux-projects-management-icon
    :route "account/accounts#projects"}
   {:text-key "navigation.account-settings-panel.users"
    :default-text "Manage Users"
    :id "account-settings-panel-users"
    :icon icons/mux-manage-users-icon
    :route (if new-users-view? "account/accounts#users_view" "account/accounts#manage_users")}
   {:text-key "navigation.account-settings-panel.dashboard"
    :default-text "Account Dashboard"
    :id "account-settings-panel-dashboard"
    :icon icons/mux-dashboards-settings-icon
    :route "account/accounts#dashboard_settings"}
   {:text-key "navigation.account-settings-panel.integration"
    :default-text "Integrations"
    :id "account-settings-panel-integration"
    :icon icons/mux-account-settings-integration-icon
    :route "account/accounts#integrations"}
   {:text-key "navigation.account-settings-panel.x-bot"
    :default-text "xBot"
    :id "account-settings-panel-x-bot"
    :icon icons/mux-x-bot-icon
    :route "account/accounts#xbot"}
   {:text-key "navigation.account-settings-panel.global-fields"
    :default-text "Global fields"
    :id "account-settings-panel-global-fields"
    :icon icons/mux-global-fields-icon
    :route "account/accounts#global_fields"}])

(def ^:private usage-and-limits-item
  {:text-key "navigation.account-settings-panel.usage-and-limits"
   :default-text "Usage & Limits"
   :id "account-settings-panel-usage-and-limits"
   :icon icons/mux-cash-payment-icon ;; TODO: replace with better icon
   :route "account/accounts#usage_and_limits"})

(defn account-setting-items []
  (cond-> (base-items @(re-frame/subscribe [::subs/new-users-view-enabled?]))
    @(re-frame/subscribe [::subs/usage-and-limits-enabled?])
    (conj usage-and-limits-item)))
